export const SET_SERVICE_LEVELS = 'SET_SERVICE_LEVELS';
export const setServiceLevels = (data) => ({
  type: SET_SERVICE_LEVELS,
  data,
});
